import React from "react";

import AutoComplete from "material-ui/AutoComplete";
import { TextField, RadioButtonGroup, RadioButton } from "material-ui";

import Label from "../label.jsx";
import CreditCardEntry from "../credit-card-entry.jsx";

import BoxOfficeGroupSalesEntry from "./box-office-group-sales-entry.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import PersonStore from "../../../stores/PersonStore";
import PersonActions from "../../../actions/PersonActions";
import PassStore from "../../../stores/PassStore";
import PassActions from "../../../actions/PassActions";
import UserStore from "../../../stores/UserStore";

import { formatPrice } from "../../../util";
import debounce from "lodash/debounce";
import api from "../../../utils/api";

class BoxOfficePayment extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      autocompletePeople: [],
      autoCompletePeopleUseServer: false,
      autocompletePasses: [],
      autoCompletePassesUseServer: false,
      loadedPersonFromQuery: false,
      loadedPassFromQuery: false
    };

    this.onNewEmailQueryDebounced = debounce(
      this.onNewEmailQuery.bind(this),
      500
    );
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onChangeName = this.onChangeName.bind(this);
    this.onNewPassQueryDebounced = debounce(
      this.onNewPassQuery.bind(this),
      500
    );
    this.onChangePassholder = this.onChangePassholder.bind(this);
    this.calculateMissingRequiredFields =
      this.calculateMissingRequiredFields.bind(this);
  }

  static getStores() {
    return [PersonStore, PassStore, UserStore];
  }

  static getPropsFromStores() {
    return {
      getPeople: PersonStore.getPeople,
      getPeopleAutocomplete: PersonStore.getPeopleAutocomplete,
      getPassesForEventBucketIncludingGlobal:
        PassStore.getPassesForEventBucketIncludingGlobal,
      getPassesAutocomplete: PassStore.getPassesAutocomplete
    };
  }

  onNewEmailQuery(raw, processedData) {
    let query = raw.text ? raw.text : raw;
    if (query.length < 2) {
      return;
    }
    PersonActions.fetchAutocomplete.defer(query);
    this.props.updateCurrentOrder({
      email: query
    });
  }

  onChangeEmail(raw, processedData) {
    const missingRequiredFields = this.calculateMissingRequiredFields();

    if (raw && raw.value) {
      this.props.updateCurrentOrder({
        missingRequiredFields,
        email: "",
        person: raw.value // person object
      });
      this.props.updateCurrentOrder({
        missingRequiredFields,
        paymentType: raw.value.details.payment_method_summary ? "saved" : null
      });
    } else {
      this.props.updateCurrentOrder({
        missingRequiredFields,
        person: null,
        email: raw || ""
      });
      if (this.state.paymentType === "saved") {
        this.props.updateCurrentOrder({ paymentType: "card" });
      }
    }
  }

  onChangeName(raw) {
    this.props.updateCurrentOrder({
      name: raw
    });
    if (this.refs.cardEntry) {
      this.refs.cardEntry.set({ name: raw });
    }
  }

  onNewPassQuery(raw) {
    let query = raw.text ? raw.text : raw;
    if (query.length < 2) {
      return;
    }
    PassActions.fetchAutocomplete.defer(query, this.props.eventBucket.id);
  }

  onChangePassholder(raw) {
    const missingRequiredFields = this.calculateMissingRequiredFields();

    if (raw && raw.value) {
      let person = PersonStore.getPersonById(raw.value.person.id);
      this.props.updateCurrentOrder({
        missingRequiredFields,
        pass: raw.value, // pass object
        person: person
      });
      this.props.updateCurrentOrder({
        missingRequiredFields,
        customerType: "passholder",
        paymentType:
          person && person.details.payment_method_summary ? "saved" : null
      });
    } else {
      this.props.updateCurrentOrder({
        missingRequiredFields,
        person: null,
        pass: null,
        pass_data: null
      });
      if (this.state.paymentType === "saved") {
        this.props.updateCurrentOrder({
          missingRequiredFields,
          paymentType: "card"
        });
      }
    }
  }

  componentDidMount() {
    // NOTE: These fetchAll calls are currently still needed for loadedPersonFromQuery and
    //       loadedPassFromQuery URLS, but are no longer slowing down user interaction in the autocomplete dropdowns
    PersonActions.fetchAll.defer();
    PassActions.fetchAllForEventBucketIncludingGlobal.defer(
      this.props.eventBucket.id
    );
    this.refs.cardEntry && this.refs.cardEntry.reset(); // reset
  }

  componentWillReceiveProps(newProps) {
    // NOTE: These fetchAll calls are currently still needed for loadedPersonFromQuery and
    //       loadedPassFromQuery URLS, but are no longer slowing down user interaction in the autocomplete dropdowns
    let people = newProps.getPeople(),
      passes = newProps.getPassesForEventBucketIncludingGlobal(
        newProps.eventBucket.id
      );

    // obtain server side data if autocomplete people feature is turned on
    let autocompletePeopleData;
    if (
      newProps.eventBucket.frontend_config.box_office_performance &&
      newProps.eventBucket.frontend_config.box_office_performance
        .autocomplete_people_server_side
    ) {
      autocompletePeopleData = newProps.getPeopleAutocomplete();
    }

    // obtain server side data if autocomplete passes feature is turned on
    let autocompletePassesData;
    if (
      newProps.eventBucket.frontend_config.box_office_performance &&
      newProps.eventBucket.frontend_config.box_office_performance
        .autocomplete_passes_server_side
    ) {
      autocompletePassesData = newProps.getPassesAutocomplete();
    }

    this.setState({
      autocompletePeople: autocompletePeopleData
        ? autocompletePeopleData
        : newProps.getPeople().map(p => {
            return {
              value: p,
              text: `${p.details.email}${
                p.details.name ? ` (${p.details.name})` : ""
              }`
            };
          }),
      autocompletePeopleUseServer: autocompletePeopleData ? true : false,
      autocompletePasses: autocompletePassesData
        ? autocompletePassesData
        : newProps
            .getPassesForEventBucketIncludingGlobal(newProps.eventBucket.id)
            .map(p => {
              return {
                value: p,
                text: `${p.name} (${p.pass_bucket.name})`
              };
            }),
      autocompletePassesUseServer: autocompletePassesData ? true : false
    });

    if (
      !this.state.loadedPersonFromQuery &&
      !this.state.loadedPassFromQuery &&
      newProps.location &&
      newProps.location.query
    ) {
      if (newProps.location.query.person) {
        let person = people.find(p => p.id === newProps.location.query.person);
        if (person) {
          setTimeout(() => {
            this.onChangeEmail({
              value: person
            });
          }, 0);
          this.setState({ loadedPersonFromQuery: true });
        }
      }
      if (newProps.location.query.pass && people.length) {
        let pass = passes.find(p => p.id === newProps.location.query.pass);
        if (pass) {
          setTimeout(() => {
            this.onChangePassholder({
              value: pass
            });
          }, 0);
          this.setState({ loadedPassFromQuery: true });
        }
      }

      if (
        newProps.terminalConnectionStatus === "connected" &&
        !newProps.orderData.paymentType
      ) {
        setTimeout(
          () => this.props.updateCurrentOrder({ paymentType: "terminal" }),
          0
        );
      }
    }
  }

  calculateMissingRequiredFields() {
    const { processedData, orderData } = this.props;

    if (processedData.mailingAddressRequired) {
      if (
        !orderData.mailing_address ||
        orderData.mailing_address.trim() === ""
      ) {
        return true;
      }

      if (
        orderData.customerType === "standard" ||
        orderData.customerType === "passholder"
      ) {
        // make sure there is a person or an email
        if (
          !orderData.person &&
          (!orderData.email || orderData.email.trim() === "")
        ) {
          return true;
        }
      } else if (orderData.customerType === "groupSales") {
        // make sure there is group data
        if (!orderData.group_sale_data || orderData.group_sale_data.length < 1)
          return true;
      }
    }

    if (
      processedData.phoneNumberRequired &&
      (!orderData.phone_number || orderData.phone_number.trim() === "")
    ) {
      return true;
    }

    return false;
  }

  getStyles() {
    return {
      passId: {
        fontSize: "0.8em",
        marginTop: -5,
        color: "#ccc"
      }
    };
  }

  render() {
    const styles = this.getStyles();

    let { orderData, processedData, headerStyle, terminalConnectionStatus } =
      this.props;

    const terminalAvailable = terminalConnectionStatus === "connected";
    const user = UserStore.getUser();
    const showExternalPos =
      user && user.global_config && user.global_config.external_pos_enabled;

    // populate orderData mailing address and phone number with existing data
    // if that information is available
    if (orderData.mailing_address === undefined) {
      if (orderData.person && orderData.person.details.mailing_address) {
        orderData.mailing_address = orderData.person.details.mailing_address;
      }
    }
    if (orderData.phone_number === undefined) {
      if (orderData.person && orderData.person.details.phone_number) {
        orderData.phone_number = orderData.person.details.phone_number;
      }
    }

    orderData.missingRequiredFields = this.calculateMissingRequiredFields();

    const orderHasGiftCard = orderData.subitems.some(item => item.gift_card);

    return (
      <div>
        <div style={headerStyle}>Payment</div>
        <Label>Order type</Label>
        <RadioButtonGroup
          name="customer-type"
          valueSelected={orderData.customerType}
          onChange={(e, customerType) =>
            this.props.updateCurrentOrder({
              customerType,
              pass: null,
              person: null,
              pass_data: null,
              group_sale_data: null
            })
          }
        >
          <RadioButton value="standard" label="Box office order" />
          <RadioButton
            value="passholder"
            label="Passholder reservation"
            disabled={orderHasGiftCard}
          />
          <RadioButton
            value="groupSales"
            label="Group sales"
            disabled={orderHasGiftCard}
          />
        </RadioButtonGroup>

        {orderData.customerType === "standard" ? (
          <form autoComplete="off">
            <AutoComplete
              floatingLabelText="Customer email address"
              id="customerName1"
              name="customerName1"
              floatingLabelFixed={true}
              hintText={
                orderData.subitems.some(i => !!i.pass_bucket)
                  ? "Required for new passholder account"
                  : "Email to receive receipt"
              }
              dataSource={this.state.autocompletePeople || []}
              searchText={
                orderData.email ||
                (orderData.person && orderData.person.details.email) ||
                ""
              }
              filter={(searchText, key) => {
                return (
                  searchText &&
                  key.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
                );
              }}
              open={true}
              maxSearchResults={10}
              menuProps={{ desktop: true, autoWidth: true, width: "auto" }}
              manuStyle={{ width: 500 }}
              style={{ width: 500, marginRight: 12 }}
              textFieldStyle={{ width: 500 }}
              fullWidth={true}
              onNewRequest={this.onChangeEmail}
              onUpdateInput={
                this.state.autocompletePeopleUseServer
                  ? this.onNewEmailQueryDebounced
                  : this.onChangeEmail
              }
            />
            <TextField
              floatingLabelText="Customer name"
              id="customerName2"
              name="customerName2"
              floatingLabelFixed={true}
              value={
                (orderData.person && orderData.person.details.name) ||
                orderData.name ||
                ""
              }
              disabled={!!orderData.person}
              onChange={e => this.onChangeName(e.target.value)}
              style={{
                display:
                  orderData.email ||
                  (orderData.person && orderData.person.details.email)
                    ? "block"
                    : "none",
                width: 300
              }}
            />
          </form>
        ) : orderData.customerType === "passholder" ? (
          <div>
            <AutoComplete
              floatingLabelText="Pass name"
              id="passholderName"
              name="passholderName"
              floatingLabelFixed={true}
              hintText="Start typing name to select..."
              dataSource={this.state.autocompletePasses || []}
              searchText={(orderData.pass && orderData.pass.name) || ""}
              filter={(searchText, key) =>
                searchText &&
                key.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
              }
              maxSearchResults={10}
              menuProps={{ desktop: true, autoWidth: true, width: "auto" }}
              style={{ width: 500, marginRight: 12 }}
              textFieldStyle={{ width: 500 }}
              fullWidth={true}
              onNewRequest={this.onChangePassholder}
              onUpdateInput={
                this.state.autocompletePassesUseServer
                  ? this.onNewPassQueryDebounced
                  : this.onChangePassholder
              }
            />
            {orderData.pass && orderData.pass.name ? (
              <div style={styles.passId}>
                ID #{orderData.pass.id} | {orderData.pass.pass_bucket.name}
              </div>
            ) : null}
          </div>
        ) : orderData.customerType === "groupSales" ? (
          <BoxOfficeGroupSalesEntry
            orderData={orderData}
            updateCurrentOrder={this.props.updateCurrentOrder}
            processedData={processedData}
          />
        ) : null}
        {processedData.mailingAddressRequired ? (
          <div>
            <TextField
              floatingLabelText={
                <span style={{ whiteSpace: "nowrap" }}>
                  Mailing address <small>(required for 1 or more items)</small>
                </span>
              }
              floatingLabelFixed={true}
              hintText={
                <div style={{ textAlign: "left" }}>
                  123 Main Street
                  <br />
                  New York, NY 10001
                </div>
              }
              value={
                typeof orderData.mailing_address !== "undefined"
                  ? orderData.mailing_address
                  : (orderData.person &&
                      orderData.person.details.mailing_address) ||
                    ""
              }
              onChange={e => {
                orderData.mailing_address = e.target.value;
                this.props.updateCurrentOrder({
                  missingRequiredFields: this.calculateMissingRequiredFields(),
                  mailing_address: e.target.value
                });
              }}
              style={{ display: "block", width: 300 }}
              multiLine={true}
              rows={2}
              rowsMax={2}
            />
          </div>
        ) : null}
        {processedData.phoneNumberRequired ? (
          <div>
            <TextField
              floatingLabelText={
                <span style={{ whiteSpace: "nowrap" }}>
                  Phone number <small>(required for 1 or more items)</small>
                </span>
              }
              floatingLabelFixed={true}
              hintText={<div style={{ textAlign: "left" }}>555-123-4567</div>}
              value={
                typeof orderData.phone_number !== "undefined"
                  ? orderData.phone_number
                  : (orderData.person &&
                      orderData.person.details.phone_number) ||
                    ""
              }
              onChange={e => {
                orderData.phone_number = e.target.value;
                this.props.updateCurrentOrder({
                  missingRequiredFields: this.calculateMissingRequiredFields(),
                  phone_number: e.target.value
                });
              }}
              style={{ display: "block", width: 300 }}
              multiLine={false}
              rows={1}
              rowsMax={1}
            />
          </div>
        ) : null}
        {orderData.email ||
        orderData.person ||
        orderData.customerType === "groupSales" ? (
          <div>
            <TextField
              floatingLabelText={
                <div style={{ whiteSpace: "nowrap" }}>
                  Additional message (prepended to confirmation email)
                </div>
              }
              floatingLabelFixed={true}
              hintText={"No message"}
              value={orderData.additional_message}
              onChange={e =>
                this.props.updateCurrentOrder({
                  additional_message: e.target.value
                })
              }
              style={{ display: "block", width: 300 }}
              multiLine={true}
            />
          </div>
        ) : null}
        <div>
          <Label>Payment method</Label>
          {processedData.total === 0 ? (
            <div>None necessary &ndash; {formatPrice(0, true)} order.</div>
          ) : (
            <div>
              <RadioButtonGroup
                name="payment-type"
                valueSelected={orderData.paymentType}
                onChange={(e, paymentType) =>
                  this.props.updateCurrentOrder({ paymentType })
                }
              >
                {(terminalAvailable
                  ? [
                      <RadioButton
                        value="terminal"
                        label={`Eventive Terminal`}
                      />
                    ]
                  : []
                )
                  .concat(
                    orderData.person &&
                      orderData.person.details.payment_method_summary
                      ? [
                          <RadioButton
                            value="saved"
                            label={`Saved credit card (${orderData.person.details.payment_method_summary})`}
                          />
                        ]
                      : []
                  )
                  .concat([
                    <RadioButton
                      value="card"
                      label={terminalAvailable ? `Manual card` : "Card"}
                    />,
                    <RadioButton value="cash" label="Cash" />,
                    <RadioButton value="check" label="Check" />
                  ])
                  .concat(
                    showExternalPos
                      ? [<RadioButton value="external" label="External POS" />]
                      : []
                  )}
              </RadioButtonGroup>
              {orderData.paymentType === "card" ? (
                <div style={{ maxWidth: 620 }}>
                  <CreditCardEntry
                    ref="cardEntry"
                    onChange={details => {
                      this.props.updateCurrentOrder({
                        paymentCardDetails: details
                      });
                    }}
                  />
                </div>
              ) : null}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default connectToStores(BoxOfficePayment);



// WEBPACK FOOTER //
// ./src/app/components/partials/box-office/box-office-payment.jsx